import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _LightTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { LightTheme5_4 } from "../LightTheme5_4";
export var LightTheme5_5 = createTheme({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_5() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_5, _BasicThemeClassForEx);
    return _createClass(LightTheme5_5, null, [{
      key: "fileUploaderBorderColor",
      get: function get() {
        return this.borderColorGrayLight;
      }
    }, {
      key: "fileUploaderDisabledTextColor",
      get: function get() {
        return this.fileUploaderDisabledColor;
      }
    }, {
      key: "fileUploaderDisabledFileTypeIcon",
      get: function get() {
        return this.fileUploaderDisabledIconColor;
      }
      //#endregion FileUploader
    }]);
  }(BasicThemeClassForExtension), _LightTheme5_.fileUploaderPaddingXSmall = '7px', _LightTheme5_.fileUploaderPaddingXMedium = '9px', _LightTheme5_.fileUploaderPaddingXLarge = '11px', _LightTheme5_.fileUploaderDisabledColor = 'rgba(0, 0, 0, 0.54)', _LightTheme5_.fileUploaderDisabledIconColor = 'rgba(0, 0, 0, 0.32)', _LightTheme5_),
  prototypeTheme: LightTheme5_4,
  themeMarkers: [markThemeVersion('5.5')]
});